import { render, staticRenderFns } from "./SaveCourseAsFavoriteButton.vue?vue&type=template&id=24e5c10e&scoped=true"
import script from "./SaveCourseAsFavoriteButton.vue?vue&type=script&lang=ts"
export * from "./SaveCourseAsFavoriteButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e5c10e",
  null
  
)

export default component.exports